const noticeStoreToastMsg = {
  /**
   *  [상점 공지사항 리스트] 상점 공지사항 리스트 가져오기
   */
  GET_NOTICE_STORE_LIST_REQUEST_SUCCESS: '상점 공지사항 리스트 가져오기 성공',
  GET_NOTICE_STORE_LIST_REQUEST_ERROR: '상점 공지사항 리스트 가져오기 실패',

  /**
   *  [상점 공지사항 리스트] 상점 공지사항 리스트 엑셀 다운로드 하기
   */
  GET_NOTICE_STORE_EXCEL_DOWNLOAD_REQUEST_SUCCESS: '상점 공지사항 리스트 엑셀 다운로드 하기 성공',
  GET_NOTICE_STORE_EXCEL_DOWNLOAD_REQUEST_ERROR: '상점 공지사항 리스트 엑셀 다운로드 하기 실패',

  /**
   *  [상점 공지사항 리스트] 선택된 상점 공지사항 삭제하기
   */
  DELETE_NOTICE_STORE_REQUEST_SUCCESS: '상점 공지사항 삭제 성공',
  DELETE_NOTICE_STORE_REQUEST_ERROR: '상점 공지사항 삭제 실패',

  /**
   *  [상점 공지사항 등록] 상점 공지사항 등록시 필요한 정보 가져오기
   */
  PREPARE_ADD_NOTICE_STORE_REQUEST_SUCCESS: '상점 공지사항 추가 준비 성공',
  PREPARE_ADD_NOTICE_STORE_REQUEST_ERROR: '상점 공지사항 추가 준비 실패',

  /**
   *  [상점 공지사항 등록] 상점 공지사항 추가하기
   */
  ADD_NOTICE_STORE_REQUEST_SUCCESS: '상점 공지사항 추가 성공',
  ADD_NOTICE_STORE_REQUEST_ERROR: '상점 공지사항 추가 실패',

  /**
   *  [상점 공지사항 등록] 상점 공지사항 가져오기
   */
  GET_NOTICE_STORE_REQUEST_SUCCESS: '상점 공지사항 가져오기 성공',
  GET_NOTICE_STORE_REQUEST_ERROR: '상점 공지사항 가져오기 실패',

  /**
   *  [상점 공지사항 편집] 상점 공지사항 편집하기
   */
  EDIT_NOTICE_STORE_REQUEST_SUCCESS: '상점 공지사항 편집 성공',
  EDIT_NOTICE_STORE_REQUEST_ERROR: '상점 공지사항 편집 실패',
};

export default noticeStoreToastMsg;
